/**
 * Swiper-based infinite auto-scroll carousels
 * Brands → يتحرك لليسار (forward)
 */

export function initButtonCarousels() {
  // انتظر Swiper يتحمل من الـ CDN
  if (typeof Swiper === "undefined") {
    setTimeout(initButtonCarousels, 100);
    return;
  }
  initBrandsSwiper();
}

function initBrandsSwiper() {
  var el = document.querySelector(".mk-brands-swiper");
  if (!el) return;

  new Swiper(".mk-brands-swiper", {
    slidesPerView: "auto",
    loop: true,
    speed: 6000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
    allowTouchMove: true,
    grabCursor: true,
  });
}

